import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

const base = {
  tags: ['talent', 'observation'],
  namespace: 'talentObservation',
  sensitivity: 'hr_restricted' as const,
  readonly: true,
  sourceTypes: ['talent_observation'],
  metadata: { projectionOwned: true, projectionOnly: true },
};

/** Classification contract for normalized talent observation records; never rendered as editable card fields. */
export const orgchartTalentObservationFieldPack: FieldPack = {
  id: 'orgchart-talent-observation',
  name: 'Talent Observation Projection',
  description: 'Effective-dated source observations used by restricted talent projections',
  version: '1.0.0',
  dependencies: ['orgchart-base'],
  fields: [
    { ...base, id: 'subjectRef', label: 'Subject', type: FieldType.TEXT },
    { ...base, id: 'dimension', label: 'Dimension', type: FieldType.TEXT },
    { ...base, id: 'observedValue', label: 'Observed Value', type: FieldType.TEXT },
    { ...base, id: 'normalizedBand', label: 'Reviewed Normalized Band', type: FieldType.TEXT },
    { ...base, id: 'scaleMappingStatus', label: 'Scale Mapping Status', type: FieldType.TEXT },
    { ...base, id: 'scaleId', label: 'Scale ID', type: FieldType.TEXT },
    { ...base, id: 'scaleVersion', label: 'Scale Version', type: FieldType.TEXT },
    { ...base, id: 'cycleId', label: 'Cycle ID', type: FieldType.TEXT },
    { ...base, id: 'observedAt', label: 'Observed At', type: FieldType.DATE },
    { ...base, id: 'effectiveFrom', label: 'Effective From', type: FieldType.DATE },
    { ...base, id: 'effectiveTo', label: 'Effective To', type: FieldType.DATE },
    { ...base, id: 'expiresAt', label: 'Expires At', type: FieldType.DATE },
    { ...base, id: 'supersedesRef', label: 'Supersedes', type: FieldType.TEXT },
    { ...base, id: 'sourceObservationId', label: 'Source Observation ID', type: FieldType.TEXT },
  ],
};
